import React, { useState } from 'react';
import {
  disbursed,
  disbursedLead,
  newLead,
  newLeadContainer,
  docPending,
  docPendingLead,
  InPrinciplePending,
  InPrinciplePendingLead,
  InPrincipleAccepted,
  InPrincipleAcceptedLead,
  sanctioned,
  sanctionedLead,
  Login,
  LoginLead,
  rejected,
  rejectedLead,
  fontBarlow,
  Open
} from './ApplicationDashboardMobile.module.css';
import moment from 'moment';
import EditLead from '../EditLead';
import numberFormat from '../../../common/constants/NumberFormat';
import _ from 'lodash';
import { getAcl } from '../../../common/utils/acl-utils';
import AssignOwner from '../AssignOwner';
import { setApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { navigate } from 'gatsby';
const ApplicationDashboardMobileEachElement = ({
  each,
  tableLoading,
  tableInfo,
  setPage,
  updateData
}) => {
  const [isAllowedToReassignRm, setIsAllowedTOReassignRm] = useState(
    getAcl()?.acl?.can_assign_rm
  );
  const [showAssignLeads, setShowAssignLeads] = useState(false);

  let statusList = {
    Disbursed: { style: disbursed, containerStyle: disbursedLead },
    'New Lead': { style: newLead, containerStyle: newLeadContainer },
    'Document Pending': { style: docPending, containerStyle: docPendingLead },
    'In Principle Pending': {
      style: InPrinciplePending,
      containerStyle: InPrinciplePendingLead
    },
    'In Principle Accepted': {
      style: InPrincipleAccepted,
      containerStyle: InPrincipleAcceptedLead
    },
    Sanctioned: { style: sanctioned, containerStyle: sanctionedLead },
    Login: { style: Login, containerStyle: LoginLead },
    Rejected: { style: rejected, containerStyle: rejectedLead }
  };

  const getLoanType = () => {
    if (each?.status == 'Login') {
      return <span> Login Amount</span>;
    } else if (each?.status == 'Sanctioned') {
      return <span> Sanc. Amount</span>;
    } else if (each?.status == 'Disbursed') {
      return <span> Dis. Amount</span>;
    } else return <span> Loan Amount</span>;
  };

  const showAmountInLakh = amount => {
    let lakhDevider = 100000;
    if (!amount) return '---';
    let lakhAmount = (amount / lakhDevider).toFixed(2);
    let amountSplitter = `${lakhAmount}`?.split('.');
    return `${numberFormat(parseInt(_.get(amountSplitter, '[0]', 0)))}.${_.get(
      amountSplitter,
      '[1]',
      '0'
    )} L`;
  };

  const getLoanAmount = () => {
    if (each?.status == 'Login') {
      return showAmountInLakh(each?.loginAmount);
    } else if (each?.status == 'Sanctioned') {
      return showAmountInLakh(each?.finalSanctionAmount);
    } else if (each?.status == 'Disbursed') {
      return showAmountInLakh(each?.disbursedAmount);
    } else return showAmountInLakh(each?.loanAmount);
  };

  const getNoOfDays = () => {
    if (!each?.sourcingDate) return '---';
    return moment().diff(moment(each?.sourcingDate), 'days');
  };
  const handleNavigation = () => {
    let leadData = {
      leadId: each.leadId,
      leadApplicantId: each.applicantId,
      applicationStatus: each.status,
      leadData: {
        leadApplicantPhone: each?.phoneNumber || '',
        leadId: each?.leadId || '',
        leadName: each?.name || '',
        loanAmount: each?.loanAmount || '',
        loanProduct: each?.product || '',
        propertyCity: each?.city || ''
      }
    };
    setApplicantionInfo(leadData);
    navigate('/app/leadprofile');
  };
  return (
    <div className="w-full px-3 py-2  bg-blue-1210">
      {showAssignLeads && isAllowedToReassignRm && (
        <AssignOwner
          leadId={each?.leadId}
          name={`${each?.leadName?.firstName || ''} ${each.leadName
            ?.middleName || ''} ${each?.leadName?.lastName || ''}`}
          ownerName={`${each?.ownerName?.firstName || ''}  ${each?.ownerName
            ?.middleName || ''} ${each?.ownerName?.lastName || ''}`}
          row={each}
          setShowReassign={setShowAssignLeads}
          onSuccess={updateData}
        />
      )}
      <div
        className={`w-full pl-1 rounded-md   ${statusList[
          each?.status || 'newLead'
        ]?.containerStyle || newLeadContainer}`}
      >
        <div className="w-full  bg-white rounded-md px-2 pt-3">
          <div className="grid grid-cols-3" onClick={handleNavigation}>
            <div className="col-span-3 w-full">
              <p
                className={`font-semibold mb-3 text-lg text-green-600 capitalize font-barlow-semi-bold`}
              >
                {`${each?.name?.firstName || ''} ${each?.name?.middleName ||
                  ''} ${each?.name?.lastName || ''}`}
              </p>
              <p
                className={`font-normal text-sm text-black-850 mt-1 ${fontBarlow}`}
              >
                {each?.leadId}
                <span
                  className={`${statusList[each?.status || 'Open']?.style ||
                    Open} ${fontBarlow} font-normal   ml-1 text-sm py-1 px-2 rounded-sm ml-2`}
                >
                  {each?.status || '---'}
                </span>
                <span
                  className={`${fontBarlow} font-normal text-black-850 bg-grey-thinGray ml-1 text-sm py-1 px-2 rounded-sm`}
                >
                  {each?.bankName || '---'}
                </span>
              </p>
            </div>
          </div>
          <div
            className="w-full grid grid-cols-3 mt-6"
            onClick={handleNavigation}
          >
            <div className="w-full">
              <p className="font-barlow font-normal text-xs text-black-1020 capitalize">
                Loan Type
              </p>
              <p
                className={` font-barlow-medium font-semibold  text-sm text-black-1025`}
              >
                {each?.product || '---'}
              </p>
            </div>
            <div className="w-full">
              <p className="font-barlow font-normal text-xs text-black-1020 ">
                {getLoanType()}
              </p>
              <p
                className={` font-barlow-medium  font-semibold  text-sm text-black-1025`}
              >
                <span className="mr-0.5"> &#8377;</span>
                {getLoanAmount()}
              </p>
            </div>

            <div className="w-full">
              <p className="font-barlow font-normal text-xs text-black-1020 ">
                No. of days
              </p>
              <p
                className={` font-barlow-medium  font-semibold  text-sm text-black-1025 `}
              >
                {getNoOfDays()}
              </p>
            </div>
          </div>
          <hr className={`text-grey-greyLight mt-4`} />
          <div className=" py-3 grid grid-cols-3">
            <div
              className={`flex col-span-2`}
              onClick={() => setShowAssignLeads(true)}
            >
              <span
                className={`font-barlow-semi-bold font-semibold capitalize ${
                  isAllowedToReassignRm ? 'text-blue-900' : ' text-black-850'
                } `}
              >
                {`${each?.rmName?.firstName || ''} ${each?.rmName?.middleName ||
                  ''} ${each?.rmName?.lastName || ''}`}
                <p
                  className={`font-barlow-semi-bold font-semibold capitalize text-black-850`}
                >
                  {moment(each?.lastActionDate).isValid() &&
                    moment(each?.lastActionDate).format('DD-MM-YY -  hh-mm A')}
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ApplicationDashboardMobileEachElement;
